import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AttachmentManagerComponent } from 'src/app/ui/components/attachment-manager/attachment-manager.component';
import { ButtonSpinnerComponent } from 'src/app/ui/components/button-spinner/button-spinner.component';
import { CardOccasionOptionsComponent } from 'src/app/ui/components/card-occasion-options/card-occasion-options.component';
import { CardOccasionComponent } from 'src/app/ui/components/card-occasion/card-occasion.component';
import { ChatFileDownloaderComponent } from 'src/app/ui/components/chat-file-downloader/chat-file-downloader.component';
import { ChatFileUploaderComponent } from 'src/app/ui/components/chat-file-uploader/chat-file-uploader.component';
import { ClassroomSelectComponent } from 'src/app/ui/components/classroom-select/classroom-select.component';
import { DownloadButtonComponent } from 'src/app/ui/components/download-button/download-button.component';
import { FileUploadItemComponent } from 'src/app/ui/components/file-upload-item/file-upload-item.component';
import { FileUploadListComponent } from 'src/app/ui/components/file-upload-list/file-upload-list.component';
import { FileUploadedItemComponent } from 'src/app/ui/components/file-uploaded-item/file-uploaded-item.component';
import { FileUploadedListComponent } from 'src/app/ui/components/file-uploaded-list/file-uploaded-list.component';
import { FileUploaderComponent } from 'src/app/ui/components/file-uploader/file-uploader.component';
import { GenericComboboxComponent } from 'src/app/ui/components/generic-combobox/generic-combobox.component';
import { IconTextButtonComponent } from 'src/app/ui/components/icon-text-button/icon-text-button.component';
import { IconTextDateCellComponent } from 'src/app/ui/components/icon-text-date-cell/icon-text-date-cell.component';
import { ProfileSelectComponent } from 'src/app/ui/components/profile-select/profile-select.component';
import { ProfileSimpleListComponent } from 'src/app/ui/components/profile-simple-list/profile-simple-list.component';
import { ProgressSumListObjectComponent } from 'src/app/ui/components/progress-sum-list-object/progress-sum-list-object.component';
import { SchoolYearComboComponent } from 'src/app/ui/components/school-year-combo/school-year-combo.component';
import { SearchBarComponent } from 'src/app/ui/components/search-bar/search-bar.component';
import { SearchRoundedBorderComponent } from 'src/app/ui/components/search-rounded-border/search-rounded-border.component';
import { SearchComponent } from 'src/app/ui/components/search/search.component';
import { SelectHierarquicalListComponent } from 'src/app/ui/components/select-hierarquical-list/select-hierarquical-list.component';
import { SelectSimpleListComponent } from 'src/app/ui/components/select-simple-list/select-simple-list.component';
import { TypeNewsSelectComponent } from 'src/app/ui/components/type-news-select/type-news-select.component';
import { UserItemComponent } from 'src/app/ui/components/user-item/user-item.component';
import { YearSelectComponent } from 'src/app/ui/components/year-select/year-select.component';
import { ClickOutsideDirective } from 'src/app/ui/directives/click-outside.directive';
import { DebounceClickDirective } from 'src/app/ui/directives/debounce-click.directive';
import { DynamicDateInputDirective } from 'src/app/ui/directives/dynamic-date-input.directive';
import { DynamicDatetimeInputDirective } from 'src/app/ui/directives/dynamic-datetime-input.directive';
import { IfRolesDirective } from 'src/app/ui/directives/if-roles.directive';
import { TouchLongPressDirective } from 'src/app/ui/directives/touch-long-press-directive';
import { TouchOutsideDirective } from 'src/app/ui/directives/touch-outside.directive';
import { RouteLinkDirective } from 'src/app/ui/directives/route-link.directive';
import { SmartLinkComponent } from 'src/app/ui/components/smart-link/smart-link.component';

import { MaterialModule } from '../app-material.module';
import { EmptyListComponent } from './components/empty-list/empty-list.component';
import { CpfPipe } from './pipe/cpf.pipe';
import { FileSizePipe } from './pipe/file-size.pipe';
import { PhonePipe } from './pipe/phone.pipe';
import { TransformTextInHiperlinkPipe } from './pipe/transform-text-in-hiperlink.pipe';
import { ArrayFilterCallbackPipe } from './pipe/array-filter-callback.pipe';
import { StripHtmlPipe } from './pipe/strip-html.pipe';
import { SanitizeHtmlPipe } from './pipe/sanitize-html.pipe';
import { PhoneFormatDirective } from 'src/app/ui/directives/phone-format.directive';
import { CustomSelectComponent } from './components/custom-select/custom-select.component';
import { UserActiveSelectComponent } from 'src/app/ui/components/user-active-select/user-active-select.component';
import { MonthFilterComponent } from 'src/app/ui/components/month-filter/month-filter.component';
import { ShowsStatusSelectComponent } from 'src/app/ui/components/shows-status-select/shows-status-select.component';
import { ShowCardComponent } from 'src/app/ui/components/show-card/show-card.component';
import { ShowsMonthSelectComponent } from 'src/app/ui/components/shows-month-select/shows-month-select.component';
import { ShowsReleasedSelectComponent } from 'src/app/ui/components/shows-released-select/shows-released-select.component';
import { BookingsReportComponent } from '../shows/components/bookings-report/bookings-report.component';
import { BookingStatusSelectComponent } from 'src/app/ui/components/booking-status-select/booking-status-select.component';
import { AttentionAlertComponent } from 'src/app/ui/components/attention-alert/attention-alert.component';

@NgModule({
  declarations: [
    SearchComponent,
    GenericComboboxComponent,
    SchoolYearComboComponent,
    SelectSimpleListComponent,
    SelectHierarquicalListComponent,
    ClassroomSelectComponent,
    ProfileSelectComponent,
    ProfileSimpleListComponent,
    YearSelectComponent,
    DownloadButtonComponent,
    IconTextButtonComponent,
    FileUploaderComponent,
    FileUploadItemComponent,
    FileUploadListComponent,
    FileUploadedListComponent,
    FileUploadedItemComponent,
    AttachmentManagerComponent,
    ChatFileUploaderComponent,
    ChatFileDownloaderComponent,
    SearchRoundedBorderComponent,
    EmptyListComponent,
    UserItemComponent,
    CardOccasionOptionsComponent,
    ProgressSumListObjectComponent,
    IconTextDateCellComponent,
    ButtonSpinnerComponent,
    CardOccasionComponent,
    TypeNewsSelectComponent,
    SearchBarComponent,
    MonthFilterComponent,
    ShowCardComponent,
    CustomSelectComponent,
    UserActiveSelectComponent,
    ShowsStatusSelectComponent,
    ShowsMonthSelectComponent,
    ShowsReleasedSelectComponent,
    BookingsReportComponent,
    BookingStatusSelectComponent,
    AttentionAlertComponent,
    SmartLinkComponent,

    ClickOutsideDirective,
    DebounceClickDirective,
    DynamicDateInputDirective,
    DynamicDatetimeInputDirective,
    IfRolesDirective,
    TouchLongPressDirective,
    TouchOutsideDirective,
    PhoneFormatDirective,
    RouteLinkDirective,

    CpfPipe,
    FileSizePipe,
    PhonePipe,
    TransformTextInHiperlinkPipe,
    ArrayFilterCallbackPipe,
    StripHtmlPipe,
    SanitizeHtmlPipe,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    OverlayModule,
  ],
  exports: [
    SearchComponent,
    GenericComboboxComponent,
    SchoolYearComboComponent,
    SelectSimpleListComponent,
    SelectHierarquicalListComponent,
    ClassroomSelectComponent,
    ProfileSelectComponent,
    ProfileSimpleListComponent,
    YearSelectComponent,
    DownloadButtonComponent,
    IconTextButtonComponent,
    FileUploaderComponent,
    FileUploadItemComponent,
    FileUploadListComponent,
    FileUploadedListComponent,
    FileUploadedItemComponent,
    AttachmentManagerComponent,
    ChatFileUploaderComponent,
    ChatFileDownloaderComponent,
    SearchRoundedBorderComponent,
    EmptyListComponent,
    UserItemComponent,
    CardOccasionOptionsComponent,
    ProgressSumListObjectComponent,
    IconTextDateCellComponent,
    ButtonSpinnerComponent,
    CardOccasionComponent,
    TypeNewsSelectComponent,
    SearchBarComponent,
    CustomSelectComponent,
    UserActiveSelectComponent,
    ShowsStatusSelectComponent,
    ShowsMonthSelectComponent,
    ShowsReleasedSelectComponent,
    ShowCardComponent,
    MonthFilterComponent,
    BookingsReportComponent,
    BookingStatusSelectComponent,
    AttentionAlertComponent,
    SmartLinkComponent,

    ClickOutsideDirective,
    DebounceClickDirective,
    DynamicDateInputDirective,
    DynamicDatetimeInputDirective,
    IfRolesDirective,
    TouchLongPressDirective,
    TouchOutsideDirective,
    PhoneFormatDirective,
    RouteLinkDirective,

    CpfPipe,
    FileSizePipe,
    PhonePipe,
    TransformTextInHiperlinkPipe,
    ArrayFilterCallbackPipe,
    StripHtmlPipe,
    SanitizeHtmlPipe,
  ],
})
/*
Componente que deverá conter todos os componentes compartilhados "entre" módulos
*/
export class SharedModule {}
